import React, { useState, useEffect } from "react";
import Header from "../../../components/Sidebar/Header";
import {
  CustemButton,
  InputBox,
  SelectDropDown,
  TextArea,
} from "../../../components/Custom";
import { EyeCloseIcon, EyeOpenIcon } from "../../../components/Icons";
import { H4FormLabel } from "../../../theme/Theme";
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ThemeColor from "../../../theme/ThemeColor";
import DisplayError from "../../../validation/DisplayError";
import HeaderName from "../../../components/Custom/HeaderName";
import { useLocation, useNavigate } from "react-router";
import validate from "../../../validation/validation";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  createOfficeDetails,
  updateOfficeDetails,
} from "../../../redux/Thunk/officeThunk";

const NewOffice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [error, setError] = useState([]);
  const [loader, setLoader] = useState(false);
  const [editOfficeDetails, seteditOfficeDetails] = useState(
    state?.editDetails ? state?.editDetails : {}
  );
  const [officeDetails, setOfficeDetails] = useState({
    OfficeName: "",
    AdminName: "",
    Email: "",
    Mobile: "",
    Address: "",
    Password: "",
    Role: "OfficeAdmin",
  });
  const [showPassword, setShowPassword] = useState(true);

  useEffect(() => {
    if (Object.keys(editOfficeDetails).length > 0) {
      setOfficeDetails({
        OfficeName: editOfficeDetails?.OfficeName || "",
        AdminName: editOfficeDetails?.AdminName || "",
        Email: editOfficeDetails?.Email || "",
        Mobile: editOfficeDetails?.Mobile || "",
        Address: editOfficeDetails?.Address || "",
        Password: editOfficeDetails?.Password || "",
      });
    }
  }, []);

  const handleChange = (e) => {
    setOfficeDetails({ ...officeDetails, [e.target.name]: e.target.value });
  };

  let check_first_digit = officeDetails?.Mobile ? officeDetails?.Mobile[0] : 0;

  let validation_input = [
    {
      tagid: "AdminName",
      text: officeDetails?.AdminName ?? "",
      required: true,
      regex_name: "text",
      errmsg: "Please Enter Admin Name.",
      allow_numbers: false,
      other_chars: " ",
      min: 3,
      max: 50,
    },
    {
      tagid: "OfficeName",
      text: officeDetails?.OfficeName ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Enter Office Name.",
      min: 1,
      max: 50,
    },
    {
      tagid: "Address",
      text: officeDetails?.Address ?? "",
      required: true,
      regex_name: "free_text",
      errmsg: "Please add the Address between 30 to 150 characters.",
      min: 30,
      max: 150,
    },
    {
      tagid: "Email",
      text: officeDetails?.Email ?? "",
      regex_name: "email",
      required: true,
      errmsg: "Please Enter Valid Email.",
    },
    Number(check_first_digit) <= 5
      ? {
          tagid: "Mobile",
          text: officeDetails?.Mobile,
          required: true,
          regex_name: "exact_x_digits",
          errmsg: "Please Enter Valid Number.",
        }
      : {
          tagid: "Mobile",
          text: officeDetails?.Mobile,
          regex_name: "exact_x_digits",
          required: true,
          errmsg: "Please Enter Valid Number",
          x_count: 10,
        },
    {
      tagid: "Password",
      text: officeDetails?.Password,
      required: true,
      regex_name: "password",
      errmsg:
        "Password must contains at least 8 characters, Including 1 UPPER case, number and special characters.",
    },
  ];

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Create and update Office details
  const onClickSubmitForm = () => {
    if (validate(validation_input)?.length == 0) {
      setLoader(true);
      if (Object.keys(editOfficeDetails)?.length == 0) {
        // Create Office Details
        dispatch(createOfficeDetails(officeDetails)).then((res) => {
          if (res.payload.success === false) {
            sweetalert("error", res?.payload?.message);
          } else {
            sweetalert("success", res?.payload?.message);
            setOfficeDetails({
              OfficeName: "",
              AdminName: "",
              Email: "",
              Mobile: "",
              Address: "",
              Password: "",
            });
            navigate("/dashboard/officelist");
          }
          setLoader(false);
        });
      } else {
        officeDetails.OfficeId = editOfficeDetails?.OfficeId;
        // Update Office details
        dispatch(updateOfficeDetails(officeDetails)).then((res) => {
          if (res.payload.success === false) {
            sweetalert("error", res?.payload?.message);
          } else {
            sweetalert("success", res?.payload?.message);
            setOfficeDetails({
              OfficeName: "",
              AdminName: "",
              Email: "",
              Mobile: "",
              Address: "",
              Password: "",
            });
            navigate("/dashboard/officelist");
          }
          setLoader(false);
        });
      }
    } else {
      setError(validate(validation_input));
    }
  };

  const sweetalert = (variant, text) => {
    Swal.fire({
      icon: variant === "error" ? "error" : "success",
      title: text,
      button: "Ok!",
    });
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <HeaderName
          headerName={
            Object.keys(editOfficeDetails).length > 0
              ? "Edit Office"
              : "Add Office"
          }
          newForm={false}
          onClickBackButton={() => navigate("/dashboard/officelist")}
        />
        <Box
          style={{
            backgroundColor: "#FFFFFF",
            margin: "5px 30px 5px 10px",
            border: "1px solid #FFFFF",
            borderRadius: "30px",
          }}
        >
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              padding: "20px 20px",
              flexDirection: "row",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            {/* Render input fields for 'Office' */}
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Office Name
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  color: ThemeColor.palette.InputTextColor,
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  width: "100%",
                  p: 0.1,
                  pl: 2,
                }}
                placeholder="Enter Office Name"
                name="OfficeName"
                value={officeDetails?.OfficeName}
                onChange={handleChange}
              />
              <DisplayError error={error} fortagid="OfficeName" />
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Admin Name
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#FFFFFF",
                  color: ThemeColor.palette.InputTextColor,
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  width: "100%",
                  p: 0.1,
                  pl: 2,
                }}
                placeholder="Enter Admin Name"
                name="AdminName"
                value={officeDetails?.AdminName}
                onChange={handleChange}
              />
              <DisplayError error={error} fortagid="AdminName" />
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Email
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  color: ThemeColor.palette.InputTextColor,
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  width: "100%",
                  p: 0.1,
                  pl: 2,
                }}
                placeholder="Enter Email"
                name="Email"
                value={officeDetails?.Email}
                onChange={handleChange}
              />
              <DisplayError error={error} fortagid="Email" />
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Mobile Number
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                sx={{
                  borderRadius: "10px",
                  color: ThemeColor.palette.InputTextColor,
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  width: "100%",
                  p: 0.1,
                  pl: 2,
                }}
                placeholder="Enter Mobile Number"
                name="Mobile"
                value={officeDetails?.Mobile}
                onChange={(e) => {
                  if (e.target.value.length <= 10) handleChange(e);
                }}
                onKeyPress={(e) => {
                  const keyCode = e.keyCode || e.which;
                  const keyValue = String.fromCharCode(keyCode);
                  const numericRegex = /^[0-9]*$/;
                  if (!numericRegex.test(keyValue)) {
                    e.preventDefault();
                  }
                }}
              />
              <DisplayError error={error} fortagid="Mobile" />
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
              <H4FormLabel
                sx={{ mb: 0.5, color: ThemeColor.palette.InputTextColor }}
              >
                Address
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <TextArea
                id="address"
                value={officeDetails?.Address}
                onChange={handleChange}
                name="Address"
                style={{
                  height: "40px",
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                }}
                placeholder="Enter Address"
              ></TextArea>
              <DisplayError error={error} fortagid="Address" />
            </Grid>

            {/* Office update the password field is hide */}
            {Object.keys(editOfficeDetails).length > 0 ? (
              <>
                <Grid sx={{ mb: 2 }}></Grid>{" "}
              </>
            ) : (
              <>
                <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                  <H4FormLabel
                    sx={{ color: ThemeColor.palette.InputTextColor }}
                  >
                    Password
                    <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
                  </H4FormLabel>
                  <InputBox
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    name="Password"
                    type={showPassword ? "password" : "text"}
                    value={officeDetails?.Password}
                    onChange={handleChange}
                    sx={{
                      width: "100%",
                      border: "1px solid rgba(0, 0, 0, 0.3)",
                      borderRadius: "10px",
                      p: 0.1,
                      pl: 1,
                    }}
                    placeholder="Password"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          style={{ ml: 1 }}
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <DisplayError error={error} fortagid="Password" />
                </Grid>
              </>
            )}
          </Grid>

          <Grid
            size={{ xs: 12, sm: 10, md: 10, lg: 12 }}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              id="save"
              variant="contained"
              disabled={loader}
              onClick={onClickSubmitForm}
              sx={{
                color: "#FFFFFF",
                backgroundColor: "#04AB44",
                "&:hover": { backgroundColor: "#04AB44", color: "#FFFFFF" },
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "10px",
                pl: 5,
                pr: 5,
                textTransform: "none",
                boxShadow: "0px 4px 6px #e1e1e1",
                mb: 4,
                letterSpacing: "1px",
              }}
            >
              {loader ? <CircularProgress size={20} color="inherit" /> : "Save"}
            </Button>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default NewOffice;
